import { IParticipatedEventItem } from "../../interfaces"
import { formatDate } from "../../utils"
import { Image } from "../."
import { Text, Title } from "../typography"

interface BadgeProps {
	event: IParticipatedEventItem
}

export const Badge = ({ event }: BadgeProps) => {
	return (
		<div className="mb-[12px] flex flex-row items-start justify-start gap-[10px]">
			<Image url={event.ticketImage} width={100} height={100} />

			<div className="flex flex-col pt-[10px]">
				<Text>{formatDate(event.date, false)}</Text>
				<Title>{event.name}</Title>
			</div>
		</div>
	)
}
